import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BtnModalTable, BtnOutlineRed } from '../../../styled-components';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useAuth } from '../../../commons/Auth';
import { useAlert } from 'react-alert';
import axios from 'axios';
import {
  DataTable,
  Field,
  NumberIafsCreatedField,
} from '../../../commons/DataTable';
import { useLoading } from '../../../commons/Loading';
import ModalInvoiceDetail from '../../../commons/ModalInvoiceDetail';
import ResultJobStatusField from '../../../commons/DataTable/ResultJobStatus';

const ModalSeePanoramicaIafs = ({ data, business }) => {
  const [t] = useTranslation('QUEUE_JOB_REQUESTS');
  const [modal, setModal] = useState(false);
  const [modalState, setModalState] = useState(false);
  const [results, setResults] = useState([]);
  const [{ newToken } = {}] = useAuth();
  const alert = useAlert();
  const { showLoading, hideLoading } = useLoading();

  console.log('business dentro:', business);

  const fetchQueueRequestResults = async () => {
    showLoading();
    const queueRequestId = data?._id || [];
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/queueJobRequests/results/${queueRequestId}`,
      {
        headers: { Authorization: newToken },
        params: {
          business,
        },
      }
    );
    hideLoading();
    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }
    setResults(response.data || []);
  };

  const toggle = (e) => {
    !!e && e.stopPropagation();
    setModal(!modal);

    if (!modal && data?.results?.length > 0) {
      fetchQueueRequestResults();
    }
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <BtnModalTable type="button" onClick={toggle}>
          VEDI DETTAGLIO
        </BtnModalTable>
      </div>

      <Modal isOpen={modal} className="new-invoice-modal">
        <ModalHeader toggle={toggle}>{t('INFO_REPORT')}</ModalHeader>
        <ModalBody>
          <DataTable
            data={results || []}
            loadingText={t('COMMON:LOADING')}
            emptyText={t('COMMON:NO_DATA')}
          >
            <Field
              className="txt-table-left"
              title="Profilo"
              source="businessName"
            />
            <NumberIafsCreatedField title="IAF creati" source="iafNumbers" />
            <ResultJobStatusField source="status" title="Stato" />
          </DataTable>
        </ModalBody>
        <ModalFooter>
          <BtnOutlineRed type="button" className="uppercase" onClick={toggle}>
            {t('COMMON:CANCEL')}
          </BtnOutlineRed>
        </ModalFooter>
      </Modal>

      <ModalInvoiceDetail
        modalState={modalState}
        setModalState={setModalState}
        onStatusChanged={fetchQueueRequestResults}
      />
    </>
  );
};

export default ModalSeePanoramicaIafs;
